module.exports = __webpack_public_path__ + "static/media/fidelity-Loader.2bd2a7a2.gif";